"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTitle3 = void 0;
var _createText = require("./createText");
const TextTitle3 = (0, _createText.createText)('title3');
exports.TextTitle3 = TextTitle3;